const state = {
    lastActivity: localStorage.getItem('lastActivity') || 0,
    idleTimeout: 4 * 60 * 60 * 1000, // 4 hours in milliseconds 
    activityCheckInterval: null
}

const mutations = {
    UPDATE_ACTIVITY(state) {
        state.lastActivity = Date.now()
        localStorage.setItem('lastActivity', state.lastActivity)
    },
    SET_ACTIVITY_INTERVAL(state, interval) {
        state.activityCheckInterval = interval
    },
    CLEAR_ACTIVITY_INTERVAL(state) {
        if (state.activityCheckInterval) {
            clearInterval(state.activityCheckInterval)
            state.activityCheckInterval = null
        }
    }
}

const actions = {
    logout({ commit, dispatch }) {
        commit('CLEAR_ACTIVITY_INTERVAL')
        localStorage.removeItem('lastActivity');
        dispatch('logoutUser')
    },
    updateActivity({ commit }) {
        commit('UPDATE_ACTIVITY')
    },
    startActivityTracking({ commit, dispatch }) {
        
        // Clear any existing interval
        commit('CLEAR_ACTIVITY_INTERVAL')
        
        // Set initial activity timestamp when tracking starts
        commit('UPDATE_ACTIVITY')
        
        // Set up activity event listeners
        const activityEvents = ['click', 'keydown', 'touchstart'];
        activityEvents.forEach(event => {
            document.addEventListener(event, () => {
                dispatch('updateActivity');
            }, { passive: true });
        });
        
        // Set up idle tracking only
        const interval = setInterval(() => {
            const now = Date.now()
            const lastActivity = parseInt(localStorage.getItem('lastActivity') || '0')
            
            // Check if user has been idle for too long
            if (now - lastActivity > state.idleTimeout) {
                dispatch('logout')
                return
            }
        }, 15 * 60 * 1000) // Check every 15 minutes 
        
        commit('SET_ACTIVITY_INTERVAL', interval)
    }
}

const getters = {
    // No getters needed - using main store getters instead
}

export default {
    state,
    mutations,
    actions,
    getters
} 